module.exports = __webpack_public_path__ + "img/product-digital-green.a6b2549b.svg";